//var $jq = jQuery.noConflict();
$.noConflict();

(function () {
  //console.log('ready');
  var headerHeight = $("header").innerHeight();
  $("#MainContent").css("padding-top", headerHeight);
  $(".top-bar-message").not(".slick-initialized").slick({
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 4500,
    speed: 1000,
    slidesToShow: 1,
    adaptiveHeight: true,
  });

  $(".mobile-menu-search-icon").click(function () {
    $(".search-mobile").toggleClass("open");
    $(".main-menu").toggleClass("open");
    $("body").toggleClass("body-overlay-mobile-nav");
  });

  $(".mobile-menu-icon").click(function () {
    $(".nav-mobile").toggleClass("open");
    $(".main-menu").toggleClass("open");
    $(".open-icon").toggleClass("hide");
    $(".close-icon").toggleClass("hide");
    $("body").toggleClass("body-overlay-mobile-nav");
  });

  $(".mobile-nav-close").click(function () {
    $(".nav-mobile").toggleClass("open");
    $("body").toggleClass("body-overlay-mobile-nav");
  });

  $(".nav-mobile .button-toggle.dropdown").click(function () {
    $(this).parent().siblings(".mobile-submenu").toggleClass("open");

    if ($(this).parent().siblings(".mobile-submenu").hasClass("open")) {
      $(this).css("transform", "rotate(180deg)");
    } else {
      $(this).css("transform", "rotate(0)");
    }
  });

  $(".site-nav--has-submenu .submenu").hover(
    function () {
      $(this).siblings("a").addClass("nav-dropdown-arrow");
    },
    function () {
      $(this).siblings("a").removeClass("nav-dropdown-arrow");
    }
  );

  $(".site-nav--has-submenu").hover(
    function () {
      $(this).children(".site-nav__link").addClass("nav-dropdown-arrow");
    },
    function () {
      $(this).children(".site-nav__link").removeClass("nav-dropdown-arrow");
    }
  );
})();
